import htmx from 'htmx.org';

htmx.config.refreshOnHistoryMiss = true;

document.addEventListener("DOMContentLoaded", function (event) {
    initLanguageSwitch();
    initToTop();

    const distributionSelector = document.querySelector('.distribution_selector');
    const distributionItems = document.querySelectorAll('.distribution_item');

    if (distributionSelector) {

        distributionSelector.addEventListener('change', function (event) {
            updateDistributionItems();
            console.log("Distribution selector changed");
        });

        function updateDistributionItems() {
            const selectedValue = distributionSelector.value;
            console.log("Selected value:", selectedValue);

            distributionItems.forEach(function (item) {
                if (item.dataset.country === selectedValue) {
                    item.style.display = 'block';
                } else {
                    item.style.display = 'none';
                }
            });
        }

        // Initial update on page load
        updateDistributionItems();

    }
});

// Language switch in the header. The markup is a button plus a list, see
// app/templates/Atwx/Sck/Includes/LanguageSwitch/LangSwitch.ss.
function initLanguageSwitch() {
    const switches = document.querySelectorAll('[data-behaviour="langswitch"]');

    switches.forEach((languageSwitch) => {
        const toggle = languageSwitch.querySelector('.langswitch_toggle');
        const menu = languageSwitch.querySelector('.langswitch_menu');

        if (!toggle || !menu) {
            return;
        }

        const close = () => {
            languageSwitch.classList.remove('langswitch--open');
            toggle.setAttribute('aria-expanded', 'false');
            menu.hidden = true;
        };

        const open = () => {
            languageSwitch.classList.add('langswitch--open');
            toggle.setAttribute('aria-expanded', 'true');
            menu.hidden = false;
        };

        toggle.addEventListener('click', () => {
            if (toggle.getAttribute('aria-expanded') === 'true') {
                close();
            } else {
                open();
            }
        });

        // Close when the focus or the pointer leaves the switch.
        document.addEventListener('click', (event) => {
            if (!languageSwitch.contains(event.target)) {
                close();
            }
        });

        languageSwitch.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                close();
                toggle.focus();
            }
        });

        languageSwitch.addEventListener('focusout', (event) => {
            if (!languageSwitch.contains(event.relatedTarget)) {
                close();
            }
        });
    });
}

// "To top" link above the footer. The href is rewritten to the current URL
// by the base tag, which goes stale after HTMX pushes a new one, so scroll
// in place instead of following it.
function initToTop() {
    document.querySelectorAll('.totop_link').forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });
}
